// extracted by mini-css-extract-plugin
module.exports = {"input":"login_input-module__input--DGgAF","password":"login_input-module__password--2oXzT"};